import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { FileUploadModule } from 'primeng/fileupload';
import { SharedModule } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { SharedPipesModule } from '@max/shared/pipes/shared-pipes.module';
import { AircraftLookupService } from '@max/aircraft/services/aircraft-lookup.service';
import { AircraftService } from '@max/aircraft/services/aircraft.service';
import { ValidationResultsModule } from '@max/shared/components/validation-results/validation-results.module';
import { SharedValidatorsModule } from '@max/shared/validators/shared-validators.module';
import { AddAircraftModalComponent } from './add-aircraft-modal/add-aircraft-modal.component';
import { AircraftRegistrationHistoryModalComponent } from './aircraft-registration-history-modal/aircraft-registration-history-modal.component';
import { AircraftRegistrationService } from '@max/aircraft/services/aircraft-registration.service';
import { AddAircraftFleetModalComponent } from './add-aircraft-fleet-modal/add-aircraft-fleet-modal.component';
import { RemoveFleetAircraftModalComponent } from './remove-fleet-aircraft-modal/remove-fleet-aircraft-modal.component';
import { ValidateAircraftFleetPaymentModalComponent } from './validate-aircraft-fleet-payment-modal/validate-aircraft-fleet-payment-modal.component';
import { AircraftBlueBookService } from '../../services/aircraft-blue-book.service';
import { MVMSpinnerBtnModule } from '../../../shared/mvm-components/mvm-spinner-btn/mvm-spinner-btn.module';
import { AircraftImportBlueBookModalComponent } from './aircraft-blue-book/aircraft-import-blue-book-modal/aircraft-import-blue-book-modal.component';
import { AircraftBlueBookImportEntryDetailModalComponent } from './aircraft-blue-book/aircraft-blue-book-import-entry-detail-modal/aircraft-blue-book-import-entry-detail-modal.component';
import { AddAircraftAddManufacturerModalComponent } from './add-aircraft-add-manufacturer-modal/add-aircraft-add-manufacturer-modal.component';

@NgModule({
    declarations: [
        AddAircraftModalComponent,
        AircraftRegistrationHistoryModalComponent,
        AddAircraftFleetModalComponent,
        RemoveFleetAircraftModalComponent,
        ValidateAircraftFleetPaymentModalComponent,
        AircraftImportBlueBookModalComponent,
        AircraftBlueBookImportEntryDetailModalComponent,
        AddAircraftAddManufacturerModalComponent
    ],
    exports: [
        AddAircraftModalComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        SharedModule,
        TableModule,
        AutoCompleteModule,
        SharedPipesModule,
        SharedValidatorsModule,
        ValidationResultsModule,
        MVMSpinnerBtnModule,
        FileUploadModule
    ],
    providers: [
        AircraftLookupService,
        AircraftService,
        AircraftRegistrationService,
        AircraftBlueBookService
    ]
})
export class AircraftSharedModule {
}
